module.exports = __webpack_public_path__ + "static/media/172-st-lucia.b7fa26ba.svg";